
import React from "react";

interface DescriptionFieldProps {
  description: string;
  onDescriptionChange: (description: string) => void;
}

const DescriptionField: React.FC<DescriptionFieldProps> = ({
  description,
  onDescriptionChange
}) => {
  return (
    <div className="space-y-1.5">
      <label htmlFor="description" className="block text-[11px] font-semibold uppercase tracking-[0.04em] text-gray-600">
        Açıklama
      </label>
      <textarea
        id="description"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        className="flex min-h-[80px] w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-[13px] text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-brand-600 focus:ring-1 focus:ring-brand-300 disabled:cursor-not-allowed disabled:opacity-50"
        placeholder="Açıklama girin"
        required
      />
    </div>
  );
};

export default DescriptionField;
